module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_5.2362ea53.png";